import urlResolver from 'admin/utils/URLResolver';
import useSWR from 'swr';
import { getter } from 'core/utils/request';

export const useClassmates = (classId: number) => {
  const { data, isLoading, error } = useSWR(
    urlResolver.reverse('api:class:classmates', { classId }),
    getter
  );

  return { data, isLoading, error };
};
